import { create } from 'zustand'
import { User } from '@/types'

const ADMIN_EMAILS = ['rkanagasikamani@gmail.com']

interface AuthState {
  user: User | null
  isLoading: boolean
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
  isAdmin: () => boolean
  logout: () => void
}

export const useAuthStore = create<AuthState>()((set, get) => ({
  user: null,
  isLoading: true,

  setUser: (user) => {
    if (user) {
      const isAdmin = ADMIN_EMAILS.includes(user.email)
      set({ user: { ...user, isAdmin } })
    } else {
      set({ user: null })
    }
  },

  setLoading: (isLoading) => set({ isLoading }),

  isAdmin: () => {
    const { user } = get()
    return user?.isAdmin ?? false
  },

  logout: () => set({ user: null }),
}))
